import React from 'react';

import { IconButton, Tooltip } from '@mui/material';

import { useResponsive } from '../../hooks/useResponsive';
import { styled } from '@mui/material/styles';

export const CustomIconButton = ({id, tooltip, ariaLabel, ariaControls, callback, icon:Icon}) => {
  const { isMobile } = useResponsive();

  return (
    <Tooltip 
      title={
        <p style = {{
          fontSize: '1em',
        }}>
          {tooltip}
        </p>
      } 
      placement={isMobile ? 'top-end' : 'bottom-start'}
      arrow>
      <StyledIconButton id={id} onClick={callback} aria-controls={ariaControls} aria-label={ariaLabel} ismobile={isMobile ? 'true' : 'false'}>
        <Icon fontSize='large'/>
      </StyledIconButton>
    </Tooltip>
  );
};

const StyledIconButton = styled(IconButton)(({theme, ismobile}) => ({
  display: 'flex',
  borderRadius : '0.6em',
  width: ismobile === 'true' ? '2em':'2.5em',
  height: ismobile === 'true' ? '2em':'2.5em',
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  border: '0.1em solid',
  background: '#FFFFFF',
  '&:hover': {
    background: theme.palette.primary.main,
    color: '#FFFFFF'
  }
}));